import { makeRootStyles } from "../theme/styles";

const useStyles = makeRootStyles(
  () => ({
    reviewSummaryContainer: {
      padding: "2rem 1.5rem",
    },
    headerContainer: {
      textAlign: "center",
    },
    main: {
      margin: "2rem 0",
    },
    itemWrapper: {
      display: "flex",
      justifyContent: "space-between",
    },
    unorderedList: {
      margin: 0,
      padding: 0,
      listStyleType: "none",
    },
    disclaimerText: {
      fontSize: "12px",
      lineHeight: "16px",
      color: "#999",
      margin: "0.5rem auto",
    },
    conditionalSections: {
      display: "flex",
      flexDirection: "column",
      gap: "1.5rem",
    },
    addEmailToReturn: {
      background: "#ececec",
      borderRadius: "10px",
      padding: "1rem",
      display: "flex",
      flexDirection: "column",
      gap: "1rem",
    },
    paragraph: {
      margin: 0,
    },
    savePreferences: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      margin: "2rem auto 0",
      maxWidth: "640px",
      "& > label + span": {
        marginTop: "1.5rem",
      },
    },
    preferencesEmail: {
      backgroundColor: "#fff",
      maxWidth: "300px",
      marginTop: "0.5rem",
    },
  }),
  { name: "N0ReviewSummaryRaw" },
);

export { useStyles };
